import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    Hidden,
    Drawer,
    SwipeableDrawer,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { withRouter } from 'react-router-dom';
import EmployeeNav from './EmployeeNav';
import GraderNav from './GraderNav';
import StudentNav from './StudentNav';
import ApplicantNav from './ApplicantNav';
import {
    STUDENT,
    ALL_STAFF,
    ADJUNCT,
    GRADER,
    APPLICANT,
} from '../General/UserTypes';

const drawerWidth = 200;

const styles = theme => ({
    drawer: {
        [theme.breakpoints.up('md')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    drawerPaper: {
        width: drawerWidth,
    },
});

class SideNav extends Component {
    handleDrawerToggle = () => {
        const { dispatch, drawerOpen } = this.props;
        dispatch({ type: 'SET_DRAWER_STATE', payload: { drawerOpen: !drawerOpen } });
    };

    render() {
        const {
            classes,
            theme,
            user,
            drawerOpen,
        } = this.props;

        return (
            <div>
                {
                    user
                    && user.first_name
                    && (
                        <nav className={classes.drawer}>
                            <Hidden mdUp implementation="css">
                                <SwipeableDrawer
                                    variant="temporary"
                                    anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                                    open={drawerOpen}
                                    onOpen={this.handleDrawerToggle}
                                    onClose={this.handleDrawerToggle}
                                    classes={{
                                        paper: classes.drawerPaper,
                                    }}
                                >
                                    {
                                        user.role === GRADER
                                        && (
                                            <GraderNav />
                                        )
                                    }
                                    {
                                        [...ALL_STAFF, ADJUNCT].indexOf(user.role) >= 0
                                        && (
                                            <EmployeeNav />
                                        )
                                    }
                                    {
                                        user.role === STUDENT
                                        && (
                                            <StudentNav />
                                        )
                                    }
                                    {
                                        user.role === APPLICANT
                                        && (
                                            <ApplicantNav />
                                        )
                                    }
                                </SwipeableDrawer>
                            </Hidden>
                            <Hidden mdDown implementation="css">
                                <Drawer
                                    classes={{
                                        paper: classes.drawerPaper,
                                    }}
                                    variant="permanent"
                                    open
                                >
                                    {
                                        user.role === GRADER
                                        && (
                                            <GraderNav />
                                        )
                                    }
                                    {
                                        [...ALL_STAFF, ADJUNCT].indexOf(user.role) >= 0
                                        && (
                                            <EmployeeNav />
                                        )
                                    }
                                    {
                                        user.role === STUDENT
                                        && (
                                            <StudentNav />
                                        )
                                    }
                                    {
                                        user.role === APPLICANT
                                        && (
                                            <ApplicantNav />
                                        )
                                    }
                                </Drawer>
                            </Hidden>
                        </nav>
                    )
                }
            </div>
        );
    }
}

SideNav.propTypes = {
    theme: PropTypes.instanceOf(Object).isRequired,
    classes: PropTypes.instanceOf(Object).isRequired,
    user: PropTypes.shape({
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        role: PropTypes.string,
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
    drawerOpen: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    user: state.user,
    drawerOpen: state.drawer.drawerOpen,
});

const appWithStyles = withStyles(styles, { withTheme: true })(withRouter(SideNav));

export default connect(mapStateToProps)(appWithStyles);
